import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'next-themes';
import '@fontsource-variable/inter';
// Panel type registrations — must run before any conversation page mounts (Spec 77 Phase D)
import './components/context-panel/registry-bootstrap';
import App from './App.js';
import './index.css';
import './generated/api-client';
import { bootstrapClientModules } from './modules/bootstrap.js';
import { installFriendlyZodMessages } from './components/form/zod-messages.js';
import { ToastProvider } from './components/ui/Toast.js';
import { startAnalytics } from './lib/analytics.js';

bootstrapClientModules();
installFriendlyZodMessages();
startAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* next-themes owns the color theme: it sets `data-theme` on <html>, which switches the
        NextAdmin palette (styles/nextadmin/css/dark.css). Light by default, as in NextAdmin. */}
    <ThemeProvider attribute="data-theme" defaultTheme="light" enableSystem disableTransitionOnChange>
      {/* Mounted at the root so `useToast()` resolves from any page — it throws rather than
          no-opping when the provider is missing, which would otherwise reintroduce the silent
          failure this replaces. */}
      <ToastProvider>
        <App />
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
